<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Plantillas de mensajes
        .text-secondary.uppercase(v-if="selected_whatsapp") {{selected_whatsapp.name}} {{selected_whatsapp.phone_number}}
      b-col.mb-2.mb-md-0(md="auto")
        b-button(variant="primary" @click="side_modal = true") Crear plantilla
      b-col(md="auto")
        b-button(variant="secondary" @click="downloadTemplates") Descargar plantillas
    b-form-row.align-items-center.mt-3.mb-3
      b-row.ml-1.align-items-center
        b-badge.ml-1(variant="light") Total:  {{templates_metrics.total}}
        b-badge.ml-2(variant='soft-success') Aprobadas: {{templates_metrics.approved}}
        b-badge.ml-2(variant='soft-danger').ml-2 Rechazadas: {{templates_metrics.rejected}}
        b-badge.ml-2(variant='soft-warning').ml-2 Pendientes:  {{templates_metrics.pending}}
    b-form-group(label="Seleccionar cuenta:", v-if="whatsapps.length > 1")
      b-form-select(v-model="selected_whatsapp", @change="getTemplates")
        option(:value="null", disabled) -- Seleccionar Whatsapp --
        option(v-for="whatsapp in whatsapps", :key="whatsapp.waba_id", :value="whatsapp") {{whatsapp.name}}
    b-overlay(:show="!selected_whatsapp && !loading")
      template(#overlay)
        h5.text-secondary.mb-0.text-center No tienes configurada ninguna cuenta de Whatsapp Business
      b-card(no-body)
        template(slot="header")
          b-form-row.align-items-center
            b-col.mb-2.mb-md-0
              b-input-group
                b-form-input(type="search", placeholder="Buscar plantilla...", v-model="search_text")
                b-input-group-append
                  b-input-group-text
                    search-icon.text-dark.icon-sm
            b-col(cols="auto")
              b-dropdown(ref="dropdown_filter", right, variant="light", no-caret, :menu-class="['min-width-drop']")
                template(slot="button-content")
                  filter-icon.icon-sm
                b-dropdown-header Filtrar plantillas
                b-dropdown-form
                  //b-form-group(label="Estado", label-size="sm")
                    k-select.disabled-white.flush(placeholder="- Estado -", :options="state_options", :disabled="loading", v-model="filter.states", @input="getTemplates", multiple, :searchable="false")
                  b-form-group(label="Categorías", label-size="sm")
                    k-select.disabled-white.flush(placeholder="- Categorías -", :options="categories_options", :disabled="loading", v-model="filter.categories", @input="getTemplates", multiple, :searchable="false")
        b-table.mb-0(ref="contacts_table", :fields="fields", :items="message_templates", responsive, show-empty, :busy="loading")
          template(v-slot:empty)
            p.mb-0.text-center.text-help {{search_text.length ? 'No hay coincidencias' : 'No hay plantillas creadas'}}
          template(v-slot:table-busy)
            .text-center
              b-spinner(variant="primary")
          template(v-slot:cell(name)="{ value }")
            small {{value}}
          template(v-slot:cell(category_name)="{ value }")
            b-badge.mr-1(variant="soft-primary") {{value}}
          template(v-slot:cell(preview)="{ value, item }")
            small.text-help(:id="item.id") {{value}}
            b-tooltip(:target="item.id", triggers="hover", boundary="window", variant="light", custom-class="description" )
              .text-left(v-for="(component, index) in item.components", :key="index")
                div(v-if="component.type === 'HEADER'")
                  h6 Cabecera
                  p(v-if="component.format === 'TEXT'") {{component.text}}
                  .text-center.mb-2(v-else-if="component.format === 'IMAGE'")
                    b-img.img-fluid(v-if="component.example && component.example.header_handle.length", :src="component.example.header_handle[0]", @error="component.example.header_handle = []", style="object-fit: contain;")
                    v-icon(v-else, name="image", scale="4")
                  .text-center.mb-2(v-else-if="component.format === 'DOCUMENT'")
                    v-icon(name="file", scale="3")
                    b-link.d-block(v-if="component.example && component.example.header_handle.length", :href="component.example.header_handle[0]" target="_blank") Documento
                  .text-center.mb-2(v-else-if="component.format === 'VIDEO'")
                    video.img-fluid(v-if="component.example && component.example.header_handle.length", :src="component.example.header_handle[0]", controls)
                    v-icon(v-else, name="video", scale="3")
                div(v-if="component.type === 'BODY'")
                  h6 Texto
                  p(v-html="parseBody(component.text)")
                div(v-if="component.type === 'FOOTER'")
                  h6 Pie de página
                  p {{component.text}}
                div(v-if="component.type === 'BUTTONS' && component.buttons && component.buttons.length")
                  h6 Botones
                  .text-info.bg-white.btn.text-break.mb-2.btn-block.btn-sm(v-for="(btn, btn_index) in component.buttons", :key="btn_index", v-if="btn.text")
                    external-link-icon.icon-sm.mr-2(v-if="btn.type === 'URL'")
                    phone-icon.icon-sm.mr-2(v-else-if="btn.type === 'PHONE_NUMBER'")
                    span {{btn.text}}
          template(v-slot:cell(language_name)="{ value }")
            b-badge.mr-1(variant="light") {{value}}
          template(v-slot:cell(status)="{ value }")
            b-badge.mr-1(:variant="value === 'Aprobado' ? 'soft-success' : (value === 'Rechazado' ?  'soft-danger' : 'soft-warning') ") {{value}}
          //template(v-slot:cell(updatedAt)="{ value }")
            div {{value ? $moment(value).format('DD MMMM YYYY') : 'No disponible'}}
          template(v-slot:cell(id)="{ item }")
            block-connector(:next_block_id="item.block_id", pill, button-only, clearable, @change="updateTemplateBlockId(item, $event)")
            b-button(variant="link", size="sm", @click.stop="confirmDelete(item).then()", v-b-tooltip.hover="'Eliminar'", :disabled="item.loading")
              b-spinner(small, variant="primary", v-if="item.loading")
              trash-icon.icon-sm.text-secondary.hover-danger(v-else)
        .card-body
          b-row.justify-content-center
            b-col(cols="3")
              b-button(variant="outline-primary", :disabled="loading", v-if="has_previous", @click="getTemplates('before')")
                chevron-left-icon.icon-md
            b-col(cols="auto", v-if="loading")
              b-spinner(small, variant="primary")
            b-col.text-right(cols="3")
              b-button(variant="outline-primary", :disabled="loading", v-if="has_next", @click="getTemplates('after')")
                chevron-right-icon.icon-md
    SideModal(v-model="side_modal", size="lg", @input="side_modal = false")
      template(v-if="side_modal")
        MessageTemplate(:categories_options="categories_options", :languages="languages", :waba_id="selected_whatsapp.waba_id", @close="side_modal = false")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import _debounce from "lodash.debounce";
import MessageTemplate from '@/components/MessageTemplate.vue'
import Select from '@/components/Select.vue'
import Download from 'downloadjs'
const templatesController = createNamespacedHelpers('message_template')
export default {
  data () {
    return {
      loading: false,
      side_modal: false,
      has_next: false,
      has_previous: false,
      before: null,
      after: null,
      selected_waba_id: null,
      selected_whatsapp: null,
      search_text: "",
      page: 1,
      filter: {
        categories: [],
        languages: null,
        states: null
      },
      whatsapps: [],
      categories_options: [
        { id: "TRANSACTIONAL", label: "Transaccional"},
        { id: "MARKETING", label: "Marketing"},
        { id: "OTP", label: "Password de un solo uso"}
      ],
      languages: [
        {id: "es", label: "Español"},
        {id: "es_MX", label: "Español (Mex)"},
        {id: "en", label: "Ingles"}
      ],
      state_options: [
        { id: "APPROVED", label: "Aprobada"},
        { id: "REVIEW", label: "Revision pendiente"},
        { id: "REJECTED", label: "Rechazada"},
      ],
      fields: [
        { key: 'name', label: 'Nombre', sortable: true },
        { key: 'category_name', label: 'Categoría', sortable: true },
        { key: 'preview', label: 'Vista previa', sortable: true },
        { key: 'language_name', label: 'Idioma' },
        { key: 'status', label: 'Estatus' },
        { key: 'id', label: 'Acciones' },
      ],
      templates_metrics: {
        total: 0,
        approved: 0,
        rejected: 0,
        pending: 0
      },
      deleteTemplateCounter:0
    }
  },
  computed: {
    ...templatesController.mapState({
      message_templates: state => state.message_templates
    }),
    templatesDownloadPath () {
      return `${API_URL}/account/${this.$route.params.account_id}/download_templates`
    },
  },
  methods: {
    ...mapActions(['message_template/whatsapps', 'message_template/all', 'message_template/update', 'message_template/destroy', 'message_template/download_templates', 'message_template/templates_metrics']),
    getWhatsapps () {
      this.loading = true
      let self = this

      this['message_template/whatsapps']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            console.log(res)
            self.whatsapps = res.resource.slice()
            if(res.resource.length == 1) {
              self.selected_whatsapp = res.resource[0]
              self.getTemplates()
            }
          }
        }
      });
    },
    getTemplatesMetrics(waba_id){
      const self = this
      this['message_template/templates_metrics']({
        waba_id,
        callback: res => {
          if (res.error) {
            this.$message.error(res.error)
          } else {
            self.templates_metrics =res.data
          }
        }
      });
    },
    getTemplates (page) {
      this.loading = true
      let self = this

      let params = {
        limit: 20,
        account_id: this.$route.params.account_id
      }
      if(page) params[page] = this[page]
      if(this.search_text) params.name = this.search_text
      if(this.filter.categories.length) params.categories = this.filter.categories.join(",")

      this['message_template/all']({
        waba_id: self.selected_whatsapp.waba_id,
        params,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.has_next = res.has_next
            self.has_previous = res.has_previous
            self.before = res.before
            self.after = res.after
            self.getTemplatesMetrics(self.selected_whatsapp.waba_id)
          }
        }
      });
    },
    searchTemplates: _debounce(function () {
      this.getTemplates()
    },1000, {leading: false, trailing: true}),
    updateTemplateBlockId (item, {next_block_id}) {
      item.loading = true
      item.block_id = next_block_id
      const self = this
      this['message_template/update']({
        ...item,
        callback: res => {
          item.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Plantilla actualizada')
          }
        }
      });
    },
    async confirmDelete (item) {
      try {
        let response = await this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la plantilla ${item.name}? No se puede deshacer.`, {
          title: 'Eliminar plantilla',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
        })
        if (response) {
          this.deleteTemplate(item)
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    deleteTemplate (item) {
      item.loading = true
      let self = this

      this['message_template/destroy']({
        waba_id: this.selected_whatsapp.waba_id,
        ...item,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
            item.loading = false
          } else {
            self.$message.success('Plantilla eliminada')
            this.removeTemplateFromList(item)
            this.getTemplatesMetrics(self.selected_whatsapp.waba_id)
          }
        }
      });
    },
    removeTemplateFromList (item) {
      this.deleteTemplateCounter++
      this.message_templates = this.message_templates.filter(t => t.id != item.id)
      if(this.deleteTemplateCounter >=20){
        this.deleteTemplateCounter = 0
        if(this.has_next)return this.getTemplates('after')
        return this.getTemplates('before')
      }
    },
    parseBody (text) {
      return text.replace(/\n/g, "<br>").replace(/\*([^*]*)\*/g, "<strong>$1</strong>")
                                        .replace(/_([^_]*)_/g, "<em>$1</em>")
                                        .replace(/~([^~]*)~/g, "<del>$1</del>")
                                        .replace(/```([^`]*)```/g, "<code>$1</code>")
    },
    async downloadTemplates (){
      try {
        let self = this
        this['message_template/download_templates']({
          waba_id:self.selected_whatsapp.waba_id,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            } else {
                 Download(res.data, `Plantillas(+${self.selected_whatsapp.phone_number}).csv`, res.headers['content-type'])
            }
          }
        })
                // const date = new Date().toLocaleDateString("es")
        // Download(res.data, `Plantillas-${date}.csv`, res.headers['content-type'])
      } catch (e) {
        console.error(e.message)
      }
    },
  },
  mounted () {
    this.getWhatsapps()
  },
  components: {'k-select': Select, MessageTemplate},
  watch: {
    search_text () {
      this.resetPagination()
      this.searchTemplates()
    },
    side_modal (value) {
      if(!value) {
        this.resetPagination()
        this.getTemplates()
      }
    }
  },
}
</script>

<style lang="scss">
 .min-width-drop {
    min-width: 360px !important
  }
 .description > .tooltip-inner {
   min-width: 300px !important;
   max-width: 300px !important;
   font-size: 13px;
 }
</style>
